import { PagePending } from "@/components/ui/PagePending";
import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/supporter/$supporterId/admins")({
  pendingComponent: PagePending,
  component: lazyRouteComponent(() => import("./+Users")),
  head: () => ({ meta: seo({ title: "Admin Users" }) }),
});
